export default __webpack_public_path__ + "static/media/bg_gelb.08375cad.png";